import React, { useEffect, useState, useRef } from 'react';
import { Modal, InputGroup, FormControl, Row, Col, Button} from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';

import userService from './../../Services/user';
import { setUserData, changeBackground } from './../../Redux/actions';

const UserModal = ({ show, handleShow, user, socket }) =>{
    const nameInput = useRef('')
    const passInput = useRef('')
    const confirmPassInput = useRef('')

    const dispatch = useDispatch();
    
    const [avatar, setAvatar ] = useState(1);
    const [bgcolor, setBgcolor] = useState(1);
    
    const errorsInitialState = {name: false, pass: false, confirmPass: false}
    const [errors, setErrors] = useState(errorsInitialState)

    const changeAvatar = action =>{
        if(action === 'back' ) setAvatar(avatar - 1)
        if(action === 'next' ) setAvatar(avatar + 1)
    }

    const handleChange = e =>{
        const {name , value } = e.target;
        if (!value) setErrors({...errors, [name]: true});
        else setErrors({...errors, [name]: false});
    }
    
    const validation = () =>{
        let flag = true, name = false, pass = false, confirmPass = false
        if(!nameInput.current.value) { flag = false; name = true } 
        if(passInput.current.value  !== confirmPassInput.current.value) { flag = false; pass = true; confirmPass = true} 
        if(name || pass ) setErrors({name, pass, confirmPass})
        return flag;
    }

    const handleSubmit = async() =>{
        if(validation()){
            // create document
            let userData = {
                ...user,
                _id: user.publicId,   
                name: nameInput.current.value,
                avatar,
                bgImg: bgcolor
            };
            if(passInput.current.value) 
            userData.pass = passInput.current.value;

            delete userData.publicId;
            delete userData.token;
            
            const res = await userService.updateUser(userData);
            if(res.success){
                
                //socket update user
                let userSocket ={
                    publicId: user.publicId,
                    name: nameInput.current.value,
                    avatar,
                    status: user.status
                }
                socket.emit('newUser', {user: userSocket})
                
                //redux update user
                let userRedux = {
                    ...user, 
                    name: nameInput.current.value,
                    avatar,
                }    

                dispatch(setUserData(userRedux));
                dispatch(changeBackground(bgcolor));
                                
                handleShow();
                setErrors(errorsInitialState);
            }
            else{
                console.log('update failure', res.error);
            }

        }
    }

    useEffect(()=>{
        if(show){
            setAvatar(user.avatar ?? 0)
            setBgcolor(user.bgImg)
            nameInput.current.value = user.name
        }
    },[show, user])

    return(
        <Modal
            show={show}
            onHide={handleShow}
            backdrop='static'
            centered
        >
            <Modal.Header closeButton>
                USER CREDENTIALS
            </Modal.Header>
            <Modal.Body className='border'>
                <Row className=' pb-3'>
                    <Col className='d-flex flex-column'>
                        <img src={require(`./../../avatars/${avatar ?? 0}.png`).default} className='w-50 pb-2 mx-auto' alt='avatar'/>
                        <div className='d-flex justify-content-center'>
                            <Button size='sm' variant='light'onClick={()=>changeAvatar('back')} disabled={avatar < 2}>{'< Avatar'}</Button>
                            <Button size='sm' variant='light'onClick={()=>changeAvatar('next')} disabled={avatar > 20}>{'Avatar >'}</Button>
                        </div>
                    </Col>
                    <Col xs={7} >
                        <InputGroup className='mb-2'>
                            <InputGroup.Prepend>
                                <InputGroup.Text>Name</InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl name='name' ref={nameInput} isInvalid={errors.name} onChange={handleChange}/>
                        </InputGroup>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} className='font12 pb-1'>
                        SELECT BACKGROUND
                    </Col>
                    <Col xs={12}>
                        <div className='d-flex flex-nowrap w-100'>
                            {
                                [1,2,3,4,5].map((i,idx)=>(
                                    <img src={require(`./../../images/back${i}.jpg`).default} width={`${100/5}%`}className={classnames('pr-1 pointer',{'img-thumbnail opacity-1': i === bgcolor})} alt={1} key={idx} onClick={()=>setBgcolor(i)}/>   
                                ))
                            }
                        </div>
                    </Col>
                    <Col>
                        
                    </Col>
                </Row>
                
                <div className='mt-3 mb-1 font12'>CHANGE PASSWORD</div>
                <Row>
                    <Col>
                        <FormControl
                            className='mb-2'
                            placeholder='Password'
                            type='password'
                            name='pass'
                            isInvalid={errors.pass}
                            onChange={handleChange}
                            ref={passInput}
                        />
                    </Col>
                    <Col>
                        <FormControl
                            placeholder='Confirm Password'
                            type='password'
                            name='confirmPass'
                            isInvalid={errors.confirmPass}
                            onChange={handleChange}
                            ref={confirmPassInput}
                        />
                    </Col>
                </Row>

                <Button className='float-right mt-4 bg-success' onClick={handleSubmit}>UPDATE</Button>
            
            </Modal.Body>
        </Modal>
    )
}

export default UserModal;